import { ListItem, Stack } from '@mui/material';
import { IUserUpdates } from 'API/Home/userUpdates';
import { useIsDesktop } from 'Hooks';
import { Row } from './Row';
import { ReferralList } from 'Modules/Home/UserUpdates/Row/ReferralList';

interface IUpdatesList {
  data: IUserUpdates[];
  setShowDialog: (dialogContent: React.ReactNode) => void;
}

export const UpdatesList = ({ data, setShowDialog }: IUpdatesList) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={isDesktop ? '48px' : '32px'}>
      <Stack gap={isDesktop ? '24px' : '20px'}>
        <Stack
          component={'ul'}
          padding={0}
          margin={0}
          gap={isDesktop ? '24px' : '20px'}
        >
          {data.map((row: IUserUpdates, index: number) => (
            <ListItem key={index} sx={{ padding: '0' }}>
              <Row
                data={row}
                setShowDialog={() =>
                  setShowDialog(
                    <ReferralList
                      data={row.entityJSON && JSON.parse(row.entityJSON)}
                    />
                  )
                }
              />
            </ListItem>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
